module.exports = __webpack_public_path__ + "static/tradee_about-483a98156d8175f149ca690c00e1a218.png";